import React from "react";
import { Route } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import { Protected } from "./Protected";

import Dashboard from "@/pages/Dashboard";
import ContentStudio from "@/pages/ContentStudio";
import BrandIdentity from "@/pages/BrandIdentity";
import Analysis from "@/pages/Analysis";
import Analytics from "@/pages/Analytics";
import LogoStudio from "@/pages/LogoStudio";
import WebsiteBuilder from "@/pages/WebsiteBuilder";
import SocialConnect from "@/pages/SocialConnect";
import Campaigns from "@/pages/Campaigns";
import Inbox from "@/pages/Inbox";
import VideoStudio from "@/pages/VideoStudio";
import Support from "@/pages/Support";
import Billing from "@/pages/Billing";
import CampaignManager from "@/pages/CampaignManager";
import PostCalendar from "@/pages/PostCalendar";
import Settings from "@/pages/Settings";
import PowerHour from "@/pages/PowerHour";
import CRM from "@/pages/CRM";
import SEO from "@/pages/SEO";
import WhiteLabel from "@/pages/WhiteLabel";
import SharePreview from "@/pages/SharePreview";
import MorningBrief from "@/pages/MorningBrief";
import OneClickCampaign from "@/pages/OneClickCampaign";
import Ads from "@/pages/Ads";
import BrandHealth from "@/pages/BrandHealth";
import WhatsAppMarketing from "@/pages/WhatsAppMarketing";
import MagicTab from "@/pages/MagicTab";

/** Helper: wrap page in Protected + DashboardLayout. */
const dash = (Page) => (
  <Protected>
    <DashboardLayout><Page /></DashboardLayout>
  </Protected>
);

export const CustomerRoutes = (
  <>
    <Route path="/dashboard" element={dash(Dashboard)} />
    <Route path="/dashboard/content" element={dash(ContentStudio)} />
    <Route path="/dashboard/brand" element={dash(BrandIdentity)} />
    <Route path="/dashboard/logos" element={dash(LogoStudio)} />
    <Route path="/dashboard/website" element={dash(WebsiteBuilder)} />
    <Route path="/dashboard/connect" element={dash(SocialConnect)} />
    <Route path="/dashboard/campaigns" element={dash(Campaigns)} />
    <Route path="/dashboard/whatsapp" element={dash(WhatsAppMarketing)} />
    <Route path="/dashboard/inbox" element={dash(Inbox)} />
    <Route path="/dashboard/video" element={dash(VideoStudio)} />
    <Route path="/dashboard/campaign-manager" element={dash(CampaignManager)} />
    <Route path="/dashboard/billing" element={dash(Billing)} />
    <Route path="/dashboard/support" element={dash(Support)} />
    <Route path="/dashboard/calendar" element={dash(PostCalendar)} />
    <Route path="/dashboard/settings" element={dash(Settings)} />
    <Route path="/dashboard/analysis" element={dash(Analysis)} />
    <Route path="/dashboard/analytics" element={dash(Analytics)} />
    <Route path="/dashboard/power-hour" element={dash(PowerHour)} />
    <Route path="/dashboard/crm" element={dash(CRM)} />
    <Route path="/dashboard/seo" element={dash(SEO)} />
    <Route path="/dashboard/whitelabel" element={dash(WhiteLabel)} />
    <Route path="/dashboard/share-preview" element={dash(SharePreview)} />
    <Route path="/dashboard/brief" element={dash(MorningBrief)} />
    <Route path="/dashboard/one-click" element={dash(OneClickCampaign)} />
    <Route path="/dashboard/ads" element={dash(Ads)} />
    <Route path="/dashboard/brand-health" element={dash(BrandHealth)} />
    <Route path="/dashboard/magic" element={dash(MagicTab)} />
  </>
);
